export default __webpack_public_path__ + "static/media/leader.09dfcca1.jpg";